import {
  Timestamp,
  arrayUnion,
  doc,
  addDoc,
  onSnapshot,
  serverTimestamp,
  updateDoc,
  deleteDoc,
  query,
  where,
  collection,
  setDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import { v4 as uuid } from "uuid";
import moment from "moment/moment";
import { customOrderByASC, customOrderByDESC } from "./helper";
import { createAction } from "./actions.retrieve";

const tableName = "daily-reports";

export const getDailyReportsInRealTime = (id, cb) => {
  return onSnapshot(
    query(collection(db, tableName), where("projectId", "==", id)),
    (doc) => {
      const dataSnaps = [];
      doc.forEach((each) => {
        const temp = each.data();
        const object = {
          ...temp,
          temp: temp.timestamp.seconds,
        };
        dataSnaps.push(object);
      });
      cb(customOrderByDESC(dataSnaps));
    }
  );
};

export const createDailyReport = (
  { report, actions },
  communityCode,
  projectId
) => {
  const selfId = uuid();
  return setDoc(doc(db, tableName, selfId), {
    id: selfId,
    communityCode,
    projectId,
    report,
    timestamp: Timestamp.now(),
  }).then(() => {
    if (actions?.length > 0) {
      return Promise.all(actions.map((each) => createAction(each, communityCode, selfId)));
    }
  });
};

export const updateDailyReport = (reportId, report) => {
  return updateDoc(doc(db, tableName, reportId), {
    report,
    editedAt: Timestamp.now(),
  });
};

export const deleteDailyReport = (reportId) => {
  return deleteDoc(doc(db, tableName, reportId));
};
